import KYC_JumioIframeContainer from './KYC_JumioIframeContainer';
export default KYC_JumioIframeContainer;